<div class="ds-modal ds-modal--auto gecros">
    <div class="ds-accent"></div>

    <div class="ds-modal__head">
        <span class="ds-modal__head-icon material-icons">sync_alt</span>
        <div>
            <h2>Datos Afiliados Gecros</h2>
            <p *ngIf="gecrosAfiliado?.nombreAfiliado">{{ gecrosAfiliado.nombreAfiliado }}</p>
        </div>
        <span class="ds-modal__spacer"></span>
        <button type="button" class="ds-icon-btn" (click)="dialogRef.close()" aria-label="Cerrar">
            <span class="material-icons">close</span>
        </button>
    </div>

    <div class="ds-modal__body">
        <app-spinner
            [show]="!flagLoad"
            [text]="'Cargando datos de Gecros...'"
            [type]="'absolute'"
            [color]="'#B1476A'"
            [trackColor]="'#4CA7C8'"
            [blurBackground]="true"
        ></app-spinner>

        <div class="ds-alert ds-alert--danger" *ngIf="flagLoad && !gecrosAfiliado">
            <span class="material-icons">error</span>
            <div>Sin datos de Gecros para esta identificación.</div>
        </div>

        <ng-container *ngIf="gecrosAfiliado">
            <div class="ds-card">
                <div class="ds-section__head">
                    <span class="material-icons">badge</span>
                    Datos del afiliado
                </div>
                <div class="ds-section__body">
                    <div class="ds-summary">
                        <div class="ds-summary__row">
                            <span class="ds-summary__key">Nombre afiliado</span>
                            <span class="ds-summary__value">{{ gecrosAfiliado?.nombreAfiliado }}</span>
                        </div>
                        <div class="ds-summary__row">
                            <span class="ds-summary__key">CUIL</span>
                            <span class="ds-summary__value">{{ gecrosAfiliado?.cuil }}</span>
                        </div>
                        <div class="ds-summary__row">
                            <span class="ds-summary__key">Nro afiliado</span>
                            <span class="ds-summary__value">{{ gecrosAfiliado?.numeroAfiliado }}</span>
                        </div>
                        <div class="ds-summary__row">
                            <span class="ds-summary__key">Estado</span>
                            <span class="ds-summary__value">{{ gecrosAfiliado?.estado }}</span>
                        </div>
                        <div class="ds-summary__row">
                            <span class="ds-summary__key">Convenio</span>
                            <span class="ds-summary__value">{{ gecrosAfiliado?.convenio }}</span>
                        </div>
                        <div class="ds-summary__row">
                            <span class="ds-summary__key">Plan</span>
                            <span class="ds-summary__value">{{ gecrosAfiliado?.plan }}</span>
                        </div>
                        <div class="ds-summary__row">
                            <span class="ds-summary__key">Observaciones</span>
                            <span class="ds-summary__value">{{ gecrosAfiliado?.observaciones || 'Sin observaciones' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ds-card" *ngIf="gecrosAfiliado?.domicilios?.length">
                <div class="ds-section__head">
                    <span class="material-icons">home</span>
                    Domicilios
                </div>
                <div class="ds-section__body">
                    <div class="ds-table-wrap">
                        <table class="ds-table">
                            <thead>
                                <tr>
                                    <th>Calle</th>
                                    <th>Altura</th>
                                    <th>Localidad</th>
                                    <th>Cód. Postal</th>
                                    <th>Provincia</th>
                                    <th>Tel. Cel.</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let domicilio of gecrosAfiliado.domicilios">
                                    <td>{{ domicilio?.calle }}</td>
                                    <td>{{ domicilio?.numero }}</td>
                                    <td>{{ domicilio?.localidad }}</td>
                                    <td>{{ domicilio?.codigoPostal }}</td>
                                    <td>{{ domicilio?.provincia }}</td>
                                    <td>{{ domicilio?.telCelular }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="ds-modal__actions">
        <button type="button" class="ds-pill ds-pill--ghost" (click)="dialogRef.close()">Cerrar</button>
        <button type="button" class="ds-pill ds-pill--primary"
            [disabled]="!gecrosAfiliado || btnSincronizar" (click)="sincronizarDatosGecros()">
            <span class="material-icons">sync</span>
            Sincronizar estos datos
        </button>
    </div>
</div>
